import styled, { css } from 'styled-components';
import { media } from '~constants/media';
import createMedia from '~utils/createMedia';
import { Value } from '~components/FeaturesList/components/Feature/styledComponents';

// for newQuiz/steps
export const customMedia = createMedia({
  lg: 1300,
});

export const Block = styled.div`
  padding: 22px 0;
  vertical-align: middle;
`;

export const Container = styled.div<{ desktopSmallView?: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ desktopSmallView }) => css`
    ${media.lg`
      flex-direction: ${desktopSmallView ? 'column' : 'row'};
    `}
  `}

  ${customMedia.lg`
    flex-direction: row;
  `}
`;

export const SliderBlock = styled.div<{ desktopSmallView?: boolean }>`
  ${media.lg`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin-right: 28px;
  `}

  ${({ desktopSmallView }) => css`
    ${media.lg`
      width: ${desktopSmallView ? '100%' : '300px'};
      max-height: ${!desktopSmallView && '280px'};
    `}

    ${customMedia.lg`
      width: ${desktopSmallView ? '40%' : '350px'};
      max-height: ${desktopSmallView && '260px'};
    `}
  `}
`;

export const DetailsBlock = styled.div`
  margin-top: 10px;
  flex-grow: 1;

  ${media.lg`
    align-self: flex-start;
    margin-top: 0;
    width: 100px; /* prevents table from slightly changing size when it collapses in chrome, value is random and it does nothing but for some reason it works ¯\_(ツ)_/¯*/
  `}
`;

export const AddToFavorites = styled.div`
  display: none;
  font-size: 15px;
  line-height: 1;
  color: #597182;
  cursor: pointer;

  &:hover {
    color: #7b98ff;
  }

  ${media.lg`
    display: inline-block;
  `}
`;
export const OfficeName = styled.div`
  display: block;

  ${media.lg`
    display: inline-block;
  `}
`;

export const Title = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
  color: #464646;

  ${media.lg`
    margin-top: 0;
    font-size: 25px;
    line-height: 27px;
  `}
`;

export const Address = styled.div`
  border: none;
  outline: none;
  border-radius: 5px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  margin-top: 16px;
  border: none;
  outline: none;
  border-radius: 5px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  font-size: 14px;
  font-weight: 300;
  color: #1d1d1b;

  ${media.lg`
    display: inline-block;
    margin-top: 10px;
    font-size: 17px;
    line-height: 17px;
  `}
`;

export const Taxes = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 30px;
`;

export const StyledFeatureValue = styled(Value)`
  margin-top: 0;
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin-top: 20px;
  color: #1d1d1b;
  padding-right: 0;

  ${media.md`
    padding-right: 60px;
    font-size: 17px;
    line-height: 26px;
  `}
`;
